module.exports = __webpack_public_path__ + "img/paquete_express.0a591e3c.svg";